export default {
  notificationId: null,
  email: null,
  userControlToken: null,
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/resolvedParams/initialState.js